(function () {
  'use strict';

  // Real Loox review quotes, same ones already used in the interactive
  // hero's Reviews reveal (snippets/nova-3d-modal.liquid). Matched
  // against the variant title by substring so casing/spacing doesn't
  // matter.
  var QUOTES = [
    {
      match: 'mango',
      text: '"...it taste great!!!"',
      author: 'Cary F., verified buyer'
    },
    {
      match: 'pina',
      text: '"Mixes superb, taste delicious"',
      author: 'Randy M., verified buyer'
    }
  ];

  function findQuote(variantTitle) {
    var key = (variantTitle || '').toLowerCase();
    for (var i = 0; i < QUOTES.length; i++) {
      if (key.indexOf(QUOTES[i].match) !== -1) return QUOTES[i];
    }
    return null;
  }

  function updateQuote(variantTitle) {
    var quote = findQuote(variantTitle);
    if (!quote) return;
    var el = document.querySelector('[data-nova-taste-quote]');
    if (!el) return;
    var textEl = el.querySelector('.nova-taste__quote-text');
    var authorEl = el.querySelector('.nova-taste__quote-author');
    if (textEl) textEl.textContent = quote.text;
    if (authorEl) authorEl.textContent = quote.author;
  }

  if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function (payload) {
      var variant = payload && payload.data && payload.data.variant;
      if (variant) updateQuote(variant.title);
    });
  }
})();
